{
  "familyId": "TAA-ONT-BIJZIN",
  "questions": [
    {
      "id": "TAA-ONT-BIJZIN-001",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "Welk deel van de zin is een bijzin? 'Ik ga naar huis omdat het regent.'",
      "options": ["omdat het regent", "Ik ga naar huis", "naar huis", "het regent"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Bijzin herkennen", "content": "Een bijzin begint met een onderschikkend voegwoord (omdat, dat, als, wanneer, hoewel, etc.) en kan niet zelfstandig bestaan. De persoonsvorm staat aan het eind.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Omdat het regent' is de bijzin. Het begint met het onderschikkend voegwoord 'omdat' en de persoonsvorm 'regent' staat aan het eind.",
        "solutionSteps": ["Zoek het onderschikkend voegwoord: 'omdat'", "De bijzin begint bij 'omdat': 'omdat het regent'", "Check: persoonsvorm 'regent' staat aan het eind ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Omdat het regent' is de bijzin (begint met 'omdat', PV aan het eind).",
          "1": "Je dacht waarschijnlijk dat het eerste deel de bijzin is. Maar 'Ik ga naar huis' is de hoofdzin — die kan zelfstandig bestaan. Onthoud: de bijzin begint bij het voegwoord.",
          "2": "Je dacht waarschijnlijk dat 'naar huis' een bijzin is. Maar dat is een bijwoordelijke bepaling van plaats, geen bijzin. Een bijzin heeft een eigen persoonsvorm.",
          "3": "Je dacht waarschijnlijk dat alleen 'het regent' de bijzin is. Maar het voegwoord 'omdat' hoort er ook bij. Onthoud: de bijzin begint bij het voegwoord."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-002",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "Welk woord is een onderschikkend voegwoord?",
      "options": ["omdat", "en", "maar", "want"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Onderschikkend vs nevenschikkend", "content": "Onderschikkend: omdat, dat, als, wanneer, hoewel, doordat, zodat, terwijl. Nevenschikkend: en, maar, want, of, dus. Onderschikkend = bijzin, nevenschikkend = twee hoofdzinnen.", "icon": "lightbulb"}}],
      "conceptId": "onderschikkend_voegwoord",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Omdat' is onderschikkend — het leidt een bijzin in. 'En', 'maar' en 'want' zijn nevenschikkend — ze verbinden twee hoofdzinnen.",
        "solutionSteps": ["Onderschikkend: omdat, dat, als, wanneer, hoewel...", "Nevenschikkend: en, maar, want, of, dus", "'Omdat' = onderschikkend"],
        "distractorExplanations": {
          "0": "Goed! 'Omdat' is onderschikkend (leidt een bijzin in).",
          "1": "Je dacht waarschijnlijk dat 'en' onderschikkend is. Maar 'en' is nevenschikkend — het verbindt twee gelijkwaardige zinnen. Onthoud: en/maar/want/of/dus = nevenschikkend.",
          "2": "Je dacht waarschijnlijk dat 'maar' onderschikkend is. Maar 'maar' is nevenschikkend. Onthoud: maar verbindt twee hoofdzinnen.",
          "3": "Je dacht waarschijnlijk dat 'want' onderschikkend is. Maar 'want' is nevenschikkend. Let op: 'want' en 'omdat' geven allebei een reden, maar 'want' is nevenschikkend en 'omdat' onderschikkend."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-003",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "Hoeveel bijzinnen heeft deze zin? 'Als het mooi weer is, gaan we naar het strand dat dichtbij ligt.'",
      "options": ["2", "1", "3", "0"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Bijzinnen tellen", "content": "Tel de onderschikkende voegwoorden: 'als' en 'dat'. Elk voegwoord leidt een bijzin in. Dus 2 bijzinnen.", "icon": "lightbulb"}}],
      "conceptId": "bijzinnen_tellen",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Er zijn 2 bijzinnen: 'als het mooi weer is' (bijzin 1, voegwoord 'als') en 'dat dichtbij ligt' (bijzin 2, voegwoord 'dat').",
        "solutionSteps": ["Zoek onderschikkende voegwoorden", "Voegwoord 1: 'als' → bijzin: 'als het mooi weer is'", "Voegwoord 2: 'dat' → bijzin: 'dat dichtbij ligt'", "Totaal: 2 bijzinnen"],
        "distractorExplanations": {
          "0": "Goed! 2 bijzinnen: 'als het mooi weer is' en 'dat dichtbij ligt'.",
          "1": "Je hebt waarschijnlijk maar één voegwoord gevonden. Kijk goed: 'als' én 'dat' zijn allebei onderschikkende voegwoorden. Onthoud: tel alle onderschikkende voegwoorden.",
          "2": "Je dacht waarschijnlijk dat er 3 bijzinnen zijn. Maar 'gaan we naar het strand' is de hoofdzin, geen bijzin. Onthoud: de hoofdzin heeft geen voegwoord aan het begin.",
          "3": "Je dacht waarschijnlijk dat er geen bijzinnen zijn. Maar 'als' en 'dat' zijn onderschikkende voegwoorden die bijzinnen inleiden. Onthoud: onderschikkend voegwoord = bijzin."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-004",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "multiple_choice",
      "question": "Wat is het verschil tussen een hoofdzin en een bijzin?",
      "options": ["Een hoofdzin kan zelfstandig bestaan, een bijzin niet", "Een hoofdzin is altijd langer", "Een bijzin staat altijd achteraan", "Een hoofdzin heeft geen persoonsvorm"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdzin vs bijzin", "content": "Een hoofdzin kan als zelfstandige zin bestaan. Een bijzin niet — die heeft de hoofdzin nodig. In een bijzin staat de persoonsvorm aan het eind.", "icon": "lightbulb"}}],
      "conceptId": "hoofdzin_vs_bijzin",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Een hoofdzin kan zelfstandig bestaan als complete zin. Een bijzin niet — die is afhankelijk van de hoofdzin. Voorbeeld: 'Het regent' (hoofdzin) vs 'omdat het regent' (bijzin — onaf zonder hoofdzin).",
        "solutionSteps": ["Hoofdzin = kan zelfstandig bestaan", "Bijzin = kan NIET zelfstandig bestaan", "Bijzin begint met onderschikkend voegwoord"],
        "distractorExplanations": {
          "0": "Goed! Een hoofdzin is zelfstandig, een bijzin niet.",
          "1": "Je dacht waarschijnlijk dat lengte het verschil is. Maar een bijzin kan langer zijn dan een hoofdzin. Het verschil is zelfstandigheid, niet lengte.",
          "2": "Je dacht waarschijnlijk dat een bijzin altijd achteraan staat. Maar een bijzin kan ook vooraan staan: 'Als het regent, blijf ik thuis.' Onthoud: positie is niet het criterium.",
          "3": "Je dacht waarschijnlijk dat een hoofdzin geen persoonsvorm heeft. Maar zowel de hoofdzin als de bijzin hebben een persoonsvorm. Het verschil is de woordvolgorde en zelfstandigheid."
        }
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-005",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "fill_in",
      "question": "Met welk onderschikkend voegwoord begint de bijzin? 'We eten binnen ... het buiten koud is.' Typ het voegwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["omdat", "doordat", "aangezien"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Voegwoord kiezen", "content": "De bijzin geeft een reden. Passende voegwoorden: omdat, doordat, aangezien. 'We eten binnen omdat het buiten koud is.'", "icon": "lightbulb"}}],
      "conceptId": "bijzin_voegwoord_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De bijzin geeft een reden waarom we binnen eten. Passende voegwoorden: omdat, doordat of aangezien.",
        "solutionSteps": ["De bijzin geeft een reden", "Passende voegwoorden voor reden: omdat, doordat, aangezien"]
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-006",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "text_highlight",
      "question": "Markeer de bijzin in de onderstaande zin.",
      "data": {
        "text": "De leerling ging naar huis omdat hij zich niet lekker voelde.",
        "correctHighlight": "omdat hij zich niet lekker voelde",
        "highlightUnit": "clause"
      },
      "correctAnswer": "omdat hij zich niet lekker voelde",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Bijzin markeren", "content": "Zoek het onderschikkend voegwoord ('omdat'). De bijzin begint bij het voegwoord en loopt door tot het einde: 'omdat hij zich niet lekker voelde'. Let op: de persoonsvorm 'voelde' staat aan het eind van de bijzin.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_highlight_basis",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De bijzin is 'omdat hij zich niet lekker voelde'. Stap 1: zoek het onderschikkend voegwoord → 'omdat'. Stap 2: de bijzin loopt van het voegwoord tot het einde van de zin (of tot de komma). Stap 3: check — de persoonsvorm 'voelde' staat aan het eind van de bijzin. Dat klopt!",
        "solutionSteps": ["Zoek het onderschikkend voegwoord: 'omdat'", "De bijzin begint bij 'omdat'", "De bijzin loopt door tot het einde: 'omdat hij zich niet lekker voelde'", "Check: persoonsvorm 'voelde' staat aan het eind ✓"]
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-007",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "text_highlight",
      "question": "Deze zin heeft twee bijzinnen. Markeer de bijzin die een VOORWAARDE aangeeft.",
      "data": {
        "text": "Als je je huiswerk af hebt, mag je buiten spelen totdat het donker wordt.",
        "correctHighlight": "Als je je huiswerk af hebt",
        "highlightUnit": "clause"
      },
      "correctAnswer": "Als je je huiswerk af hebt",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Soorten bijzinnen", "content": "Er zijn twee bijzinnen: 'Als je je huiswerk af hebt' (voorwaarde — voegwoord 'als') en 'totdat het donker wordt' (tijdsbepaling — voegwoord 'totdat'). De vraag vraagt naar de VOORWAARDE, dus de bijzin met 'als'.", "icon": "lightbulb"}}],
      "conceptId": "bijzin_highlight_voorwaarde",
      "variantIndex": 7,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Er zijn twee bijzinnen in deze zin. 'Als je je huiswerk af hebt' geeft een voorwaarde aan (voegwoord 'als'). 'Totdat het donker wordt' geeft een tijdsbepaling aan (voegwoord 'totdat'). De vraag vraagt naar de voorwaarde, dus 'Als je je huiswerk af hebt' is het juiste antwoord. Dit is hogere orde: je moet niet alleen bijzinnen herkennen, maar ook hun functie bepalen.",
        "solutionSteps": ["Zoek alle onderschikkende voegwoorden: 'als' en 'totdat'", "Bepaal de functie: 'als' = voorwaarde, 'totdat' = tijdsbepaling", "De voorwaarde-bijzin is: 'Als je je huiswerk af hebt'"]
      }
    },
    {
      "id": "TAA-ONT-BIJZIN-008",
      "familyId": "TAA-ONT-BIJZIN",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "zinsontleding",
      "subSkill": "ontl_bijzin",
      "questionType": "ordering",
      "question": "Zet de woorden in de juiste volgorde zodat er een correcte bijzin ontstaat. Begin met het voegwoord.",
      "data": {
        "items": ["omdat", "de trein", "te laat", "was"],
        "correctOrder": [0, 1, 2, 3]
      },
      "correctAnswer": "omdat de trein te laat was",
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Woordvolgorde in bijzinnen", "content": "In een bijzin staat de persoonsvorm (pv) aan het EIND. De volgorde is: voegwoord + onderwerp + rest + persoonsvorm. Dus: 'omdat' (voegwoord) + 'de trein' (onderwerp) + 'te laat' (rest) + 'was' (pv).", "icon": "lightbulb"}}],
      "conceptId": "bijzin_woordvolgorde",
      "variantIndex": 8,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "In een bijzin staat de persoonsvorm aan het eind. De juiste volgorde is: 'omdat de trein te laat was'. Stap 1: begin met het voegwoord ('omdat'). Stap 2: dan het onderwerp ('de trein'). Stap 3: dan de rest ('te laat'). Stap 4: de persoonsvorm ('was') komt aan het eind. Vergelijk met de hoofdzin: 'De trein was te laat' — daar staat de pv op de tweede plaats.",
        "solutionSteps": ["Begin met het voegwoord: 'omdat'", "Dan het onderwerp: 'de trein'", "Dan de rest: 'te laat'", "Persoonsvorm aan het eind: 'was'", "Resultaat: 'omdat de trein te laat was'"]
      }
    }
  ]
}